import { render, staticRenderFns } from "./VideoBoxControl.vue?vue&type=template&id=6f136168&scoped=true&"
import script from "./VideoBoxControl.vue?vue&type=script&lang=js&"
export * from "./VideoBoxControl.vue?vue&type=script&lang=js&"
import style0 from "./VideoBoxControl.vue?vue&type=style&index=0&id=6f136168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f136168",
  null
  
)

export default component.exports